import { screenSm } from 'constants/styles/breakpoints';
import styled from 'styled-components';

export const CertificationsEmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  padding: 10px 0;
  width: 100%;
  ${screenSm} {
    padding: 20px 40px;
  }
`;

export const Info = {
  Container: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    text-align: center;
    color: var(--black-dark);
  `,
  Title: styled.h2`
    margin: 0;
    font-size: 16px;
    line-height: 24px;
    font-weight: 700;
    ${screenSm} {
      font-size: 24px;
      line-height: 32px;
    }
  `,
  Text: styled.p`
    font-size: 14px;
    line-height: 20px;
    margin: 10px 0 0;
    max-width: 735px;
    ${screenSm} {
      font-size: 20px;
      line-height: 26px;
    }
  `,
  CtaWrapper: styled.div`
    display: flex;
    align-items: center;
    margin-top: 20px;
  `,
};

export const EmptyStateImage = styled.img`
  width: 100%;
  height: auto;
  max-width: 339px;
`;
